import { installAppTitle, type AppTitleEntry } from "@yjsgames/app-title";
import appTitleData from "../data/generated/appTitle.json";

/** appTitle.tsv → generated json (SSoT). 타입은 패키지 AppTitleEntry와 1:1. */
const APP_TITLE_ENTRIES = appTitleData as AppTitleEntry[];

/**
 * 디바이스 언어로 브라우저 탭 제목(document.title) + `<html lang>`을 현지화한다.
 * 부팅 매우 초기(main.ts boot 첫 줄)에 1회 호출 — 첫 화면부터 현지화된 제목 노출.
 *
 * ⚠ **디바이스 언어 기준**(navigator.language)이지 인게임 설정 언어 기준이 아니다. 앱 제목은
 *   OS 레벨 라벨 성격이라 사용자가 게임 내에서 언어를 바꿔도 탭 제목은 디바이스 언어를 따른다
 *   (네이티브 런처 라벨 = Android `values-<lang>/strings.xml`과 동일 정신). 데이터 SSoT는
 *   `data/appTitle.tsv`(i18n language_*.tsv와 분리). SSR/노드 환경에서는 no-op.
 */
export function installLocalizedAppTitle(): void {
  if (typeof document === "undefined" || typeof navigator === "undefined") return;
  installAppTitle(APP_TITLE_ENTRIES, document, navigator);
}
